import { forwardRef, useEffect } from 'react';

import { app } from 'core';
import { getLocationPathname } from 'core/utilities';
import { useDispatch } from 'react-redux';

import { Stage } from './Carousel.components.styles';

import type { StageProps } from './Carousel.components.d';

const CarouselStage = forwardRef(
  ({ children, state, controls }: Omit<StageProps, 'as' | 'ref'>, ref?: StageProps['ref']) => {
    const { page, selectable, autoplay } = state;
    const dispatch = useDispatch();
    const pathname = getLocationPathname();

    useEffect(() => {
      if (!pathname.includes('departamentos') || !autoplay) {
        return;
      }
      dispatch(app.actions.homeBanner({ position: page, type: 'view' }));
    }, [page, autoplay]);

    return (
      <Stage
        ref={ref}
        aria-describedby="focus"
        aria-label="carousel"
        data-selectable={selectable}
        data-testid="carousel-wrapper"
        data-activepage={page}
        tabIndex={0}
        onClick={controls.openModal}
      >
        {children}
      </Stage>
    );
  },
);

CarouselStage.displayName = 'CarouselStage';

export default CarouselStage;
